module.exports = __webpack_public_path__ + "img/87.60097b98.jpg";